import Vue from "vue";
import Router from "vue-router";
const MorderCenter = () => import("./views/MorderCenter");//订单列表
const MorderDetails = () => import("./views/MorderDetails");//订单详情
const Mprompt = () => import("./views/Mprompt");//团队预约提示
const Ptype = () => import("./views/ptype");//团队预约提示

const Plogin = () => import("./views/Plogin");//pc端登录
const Pindex = () => import("./views/Pindex");//pc端预约+团队预约
const PorderCenter = () => import("./views/PorderCenter");//pc端订单列表

import { getMToken, getPToken } from "./token";
Vue.use(Router);
//没有token时也不跳转的页面，'orderCenter', 'appointment'会嵌入小程序中所以不容许跳转
let wxlist = [ "Plogin"]

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   name: "Mappointment",
    //   component: Mappointment
    // },
    {
      path: "/",
      name: "Plogin",
      component: Plogin
    },
    {
      path: "/Pindex",
      name: "Pindex",
      component: Pindex
    },
    {
      path: "/MorderCenter",
      name: "MorderCenter",
      component: MorderCenter
    },
    {
      path: "/PorderCenter",
      name: "PorderCenter",
      component: PorderCenter
    },
    {
      path: "/MorderDetails/:id",
      name: "MorderDetails",
      component: MorderDetails
    },
    {
      path: "/Mprompt/:id",
      name: "Mprompt",
      component: Mprompt
    },
    {
      path: "/ptype",
      name: "ptype",
      component: Ptype
    }
    
  ]
});
router.beforeEach((to, from, next) => {
  if (wxlist.lastIndexOf(to.name) == -1) {
    if (getMToken()||getPToken()) {
      next()
    } else {
      let result = true;
      if (result) return next({
        name: 'Plogin',
      })
      if (!result) return next({
        name: 'Mappointment',
        query: {
          redirect: to.path
        }
      })

    }
  } else {
    next()
  }
})
export default router;